// import React from "react"
// import { Auth0Provider } from "@auth0/auth0-react"
// import { navigate } from "gatsby"
import "./src/style/global.css"
import Clarity from "@microsoft/clarity" // Import the Microsoft Clarity library

export const onInitialClientRender = () => {
  if (process.env.NODE_ENV === "production") {
    // Only run this in production mode
    Clarity.init(process.env.GATSBY_MICROSOFT_CLARITY_PROJECT_ID) // Initialize Microsoft Clarity with your project ID
  }
}

// const onRedirectCallback = appState => {
//   // Use Gatsby's navigate method to replace the url
//   navigate(appState?.returnTo || "/", { replace: true })
// }

// export const wrapRootElement = ({ element }) => {
//   return (
//     <Auth0Provider
//       domain={process.env.GATSBY_AUTH0_DOMAIN}
//       clientId={process.env.AUTH0_CLIENTID}
//       redirectUri={window.location.origin}
//       onRedirectCallback={onRedirectCallback}
//     >
//       {element}
//     </Auth0Provider>
//   )
// }
